import { all, call, put, takeLatest } from "redux-saga/effects";
import { request } from "@app/services";

import * as endpoints from "./endpoints";
import { filterCars, filterCarsFailed, filterCarsSuccess, usedCars, usedCarsFailed, usedCarsSuccess } from "./slice";

//--------------------GetUsedCarsSagas-------------------------

function* usedCarsSaga(action: ReturnType<typeof usedCars>): any {
  try {
    const { category, limit, page, search } = action.payload;
    const response = yield call(
      request.get,
      `${endpoints.usedCars}?search=${
        search ? search : ""
      }&category=${category}&limit=${limit}&page=${page}`
    );
    yield put(usedCarsSuccess(response));
  } catch (error: any) {
    yield put(usedCarsFailed(error));
  }
}

//--------------------GetCarsWithFilterSagas-------------------------

function* filterCarsSaga(action: ReturnType<typeof filterCars>): any {
  try {
    const params = action.payload;
    const queryParams = Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== null && value !== "")
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
      .join("&");

      const url = `${endpoints.carsWithFilter}${queryParams ? `?${queryParams}` : ""}`;
      
    const response = yield call(
      request.get,url);
    yield put(filterCarsSuccess(response));
  } catch (error: any) {
    yield put(filterCarsFailed(error));
  }
}

function* usedCarsSagas() {
  yield all([takeLatest(usedCars, usedCarsSaga),takeLatest(filterCars,filterCarsSaga)]);
}

export { usedCarsSagas };
